import React, { useState } from 'react';
import { Button, Card, Menu, Text } from '@fragments';
import { IconTrendingUp, IconInfinity, IconChartLine } from '@tabler/icons-react';
import TopicScore from '../../../../components/TopicScore';
import { SourceChips } from '../../../../components/SourceCitation';
import { STUDIO_FORMATS, formatAvailable } from '../../../../enums/formats';
import './styles.scss';

export const categoryLabel = tag => tag.charAt(0).toUpperCase() + tag.slice(1);

// One topic, top to bottom: classification, with relevance and the way to use it (offered
// to a format) on the right; its categories; the topic and why it fits the creator, the
// sources right under it, and the trend signal. No footer. Formats not released yet stay
// listed, marked "soon".
export default function TopicCard({ topic, studio: s, index }) {
  const { t } = s;
  const [open, setOpen] = useState(false);
  const trending = topic.classification === 'trending';
  const eligible = topic.eligible_for_generation;
  const formats = STUDIO_FORMATS.map(format => ({
    id: format.id,
    label: t(format.labelKey),
    icon: <format.icon />,
    disabled: !formatAvailable(format, s.capabilities),
    right: formatAvailable(format, s.capabilities) ? undefined : <Text.caption contrast={5}>{t('soon')}</Text.caption>,
    onClick: () => s.startFromTopic(topic, format.id),
  }));
  const use = <Button size="small" variant="rounded" color="inverse" dropdown preventLoading disabled={!eligible}
    aria-haspopup="menu" aria-expanded={open} tooltip={eligible ? undefined : t('topicUnavailable')}>{t('trendingUse')}</Button>;
  return <Card className="studio-trend-card" style={{ '--studio-trend-index': index }}>
    <div className="studio-trend-card__meta">
      <Text.caption contrast={6} left={trending ? <IconTrendingUp /> : <IconInfinity />}>{t(trending ? 'trending' : 'evergreen')}</Text.caption>
      <div className="studio-trend-card__actions">
        <TopicScore topic={topic} t={t} />
        {eligible ? <Menu items={formats} placement="bottom-end" onOpenChange={setOpen} header={<Text.subheading contrast={6}>{t('trendingUseIn')}</Text.subheading>}>{use}</Menu> : use}
      </div>
    </div>
    {topic.niche_tags?.length > 0 && <ul className="studio-trend-card__tags" aria-label={t('trendingCategories')}>
      {topic.niche_tags.map(tag => <li key={tag}><Text.caption contrast={7}>{categoryLabel(tag)}</Text.caption></li>)}
    </ul>}
    <Text.h5 weight={500} contrast={9} maxLines={3}>{topic.title}</Text.h5>
    <Text.p contrast={7} maxLines={3}>{topic.relevance_reason}</Text.p>
    <SourceChips evidence={topic.evidence} t={t} />
    {topic.trend_evidence && <div className="studio-trend-card__signal"><IconChartLine aria-hidden="true" /><Text.caption contrast={6} maxLines={2}>{topic.trend_evidence}</Text.caption></div>}
  </Card>;
}
